import AreaSelection from "Components/AreaSelection/AreaSelection";
import { AutocompleteEntry } from "Components/Autocomplete/AutocompleteEntry";
import ContentView from "Components/ContentView/ContentView";
import { IAreaSelectionUtil } from "Interfaces/Utils/IAreaSelectionUtil";
import { IChipUtil } from "Interfaces/Utils/IChipUtil";
import { resolve } from "inversify-react";
import { Area } from "Models/Areas/Area";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAreaAction } from "Store/Areas/AreaAction";
import { IAreaState } from "Store/Areas/AreaState";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateAction } from "Store/TaskTemplates/TaskTemplateAction";
import { TaskTemplateFilterState } from "Store/TaskTemplates/TaskTemplateFilterState";
import { ITaskTemplateState } from "Store/TaskTemplates/TaskTemplateState";
import i18n from "Translations/i18n";
import styles from "./TaskTemplateListOverview.scss";
import TaskTemplateListOverviewHeader from "./TaskTemplateListOverviewHeader/TaskTemplateListOverviewHeader";
import TaskTemplateListView from "./TaskTemplateListView/TaskTemplateListView";

const areaAction: IAreaAction = ServiceProvider.get<IAreaAction>(Types.IAreaAction);
const taskTemplateAction = ServiceProvider.get<ITaskTemplateAction>(Types.ITaskTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getCompanyAreas: () =>
        dispatch(areaAction.getAreasByCompanyId()),
    getArrangeTaskTemplatesAsync: () =>
        dispatch(taskTemplateAction.getArrangeTaskTemplatesAsync()),
    updateArrangeFilterAsync: (filter: TemplateFilter) =>
        dispatch(taskTemplateAction.updateArrangeFilterAsync(filter))
});

const mapStateToProps = (state: IApplicationState) => ({
    taskTemplateState: state.taskTemplateState,
    areaState: state.areaState
});

interface IProps {
    areaState: IAreaState;
    taskTemplateState: ITaskTemplateState;
    getCompanyAreas: () => Action;
    getArrangeTaskTemplatesAsync: () => Action;
    updateArrangeFilterAsync: (filter: TemplateFilter) => Action;
}

interface IState {
    showAutocomplete: boolean;
    areas: Area[];
    selectedArea?: Area;
    autocompleteEntries?: AutocompleteEntry[];
    arrangeFilter: TaskTemplateFilterState;
}

export class TaskTemplateListOverview extends React.Component<IProps, IState> {
    @resolve(Types.IAreaSelectionUtil) public areaSelectionUtil: IAreaSelectionUtil;
    @resolve(Types.IChipUtil) public chipUtil: IChipUtil;

    constructor(props: IProps) {
        super(props);

        this.state = {
            showAutocomplete: false,
            areas: [],
            autocompleteEntries: undefined,
            arrangeFilter: props.taskTemplateState.currentArrangeFilter || {},
            selectedArea: props.taskTemplateState.currentArrangeFilter ? props.taskTemplateState.currentArrangeFilter.area : undefined
        };

        this.props.getCompanyAreas();
        this.loadTaskTemplates();

        this.onAreaSelectionChanged = this.onAreaSelectionChanged.bind(this);
    }

    private loadTaskTemplates() {
        this.props.getArrangeTaskTemplatesAsync();
    }

    public onAreaSelectionChanged(selectedArea?: Area) {
        const newFilter = { ...this.state.arrangeFilter, area: selectedArea };
        this.setState({ showAutocomplete: false, selectedArea, arrangeFilter: newFilter });
        this.props.updateArrangeFilterAsync(newFilter);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const state: Partial<IState> = {};

        if (nextProps.areaState.companyAreas !== prevState.areas) {
            state.areas = nextProps.areaState.companyAreas;
        }

        return state;
    }

    public render() {
        return (
            <ContentView>
                <TaskTemplateListOverviewHeader />
                <AreaSelection className={styles.areaSelection} titleClassName={styles.title} iconClassName={styles.icon} areaSearchTextboxClassName={styles.noShadow} selectedArea={this.state.selectedArea} onSelectionChanged={this.onAreaSelectionChanged} showAreaNavigator={false} title={i18n.t("tasks.area.highlightAreas")} />
                <div className={styles.flexWrapper}>
                    <TaskTemplateListView filteredAreaIds={this.areaSelectionUtil.getChildrenIds(this.state.arrangeFilter.area)} />
                </div>
            </ContentView>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplateListOverview);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListOverview.tsx